
import ColorPicker from './color-picker.vue';
import SortPicker from './sort-picker.vue';

export default {
  name: "cleanerPicker",
  components: {
    SortPicker,
    ColorPicker
  },
  mounted() {

  },
  created() {
    let t = this;

    t.$eventBus.$on('trigger-selectedCleanerChanged', () => {
      t.emitChanged();
    });

    if (localStorage['cleaner_color_dict']) {
      t.colorDict = JSON.parse(localStorage['cleaner_color_dict']);
    }

    if (localStorage['apply_cleaner_color'] == 1) {
      t.applyColors = true;
    }

    axios.get("employee?role=2").then((res) => {
      if (res.data.status == 1) {
        let items = res.data.options.items;
        items.forEach(item => {
          item.bgColor = '';
          if (t.colorDict[item.id]) {
            item.bgColor = t.colorDict[item.id];
          }
        });
        t.cleanerDict = listToDict(items);

        let selection = [];

        if (localStorage["selected_cleaner_ids"]) {
          selection = localStorage["selected_cleaner_ids"].split(",");
          selection.forEach(id => {
            if (t.cleanerDict[id])
              t.cleanerDict[id].selected = true;
            t.list.selectedCleaner.push(t.cleanerDict[id]);
          });
        }

        t.emitChanged();

        t.list.cleaner = items;
      }
    });
  },
  activated: function (el) {
  },
  deactivated() {
  },
  methods: {
    setColor(item) {
      if (item == this.cleaner) {
        this.cleaner = null;
        return;
      }
      this.cleaner = item;
      this.$refs.colorPicker.setColor(item.bgColor || '');
    },
    emitChanged() {
      let t = this;
      localStorage['apply_cleaner_color'] = t.applyColors ? 1 : 0;
      t.$eventBus.$emit('selectedCleanerChanged', t.list.selectedCleaner, t.applyColors);
    },
    onColorChange(color) {
      this.cleaner.bgColor = color;
      let dict = localStorage['cleaner_color_dict'];
      if (dict) {
        dict = JSON.parse(dict);
      }
      else {
        dict = {};
      }
      dict[this.cleaner.id] = color;
      localStorage['cleaner_color_dict'] = JSON.stringify(dict);
      // this.emitChanged();
    },
    refreshSelection() {
      let t = this;
      let arr = [];

      let res = t.$refs.sortPicker.selection;

      if (res.length > 0) {
        res.forEach(item => {
          arr.push(item.id);
          item.selected = true;
        });
        localStorage["selected_cleaner_ids"] = arr.join(",");
      }

      t.list.selectedCleaner.clear();
      t.list.selectedCleaner.append(res);
      t.$forceUpdate();
    },
  },
  data() {
    return {
      cleaner: null,
      showCleanersEditor: false,
      applyColors: false,
      colorDict: {},
      list: {
        cleaner: [],
        selectedCleaner: [],
      },
      cleanerDict: {},
    };
  },
};
